"use client";
import { TypeContactUsSkeleton } from "@/lib/contentful/contentfulTypes";
import { Entry } from "contentful";
import dynamic from "next/dynamic";
import clsx from "clsx";
import { parsePhoneNumber } from "libphonenumber-js";

export function ContactUs({
  model,
}: {
  model: Entry<TypeContactUsSkeleton, "WITHOUT_LINK_RESOLUTION", string>;
}) {
  const info = model;
  const DynamicMap = dynamic(
    () => import("@/contentful-components/ContactInfoSection/LeafletMap"),
    {
      ssr: false,
    },
  );

  return (
    <section>
      <h3 className={clsx("fontAcumin", "text-dark-blue-80", "mb-4")}>
        {info.fields.entryTitle}
      </h3>
      <div
        className={clsx(
          "grid",
          "grid-cols-1",
          "md:grid-cols-2",
          "gap-2",
          "text-dark-blue-60",
        )}
      >
        <h4 className={clsx("md:text-xl")}>{info.fields.phoneHeader}</h4>
        <a
          href={`tel:${parsePhoneNumber(
            info.fields.phone,
            "SE",
          )?.formatInternational()}`}
          className={clsx("hover:underline", "text-dark-blue-80")}
          aria-label="Phone Number"
        >
          {parsePhoneNumber(info.fields.phone, "SE")?.formatInternational()}
        </a>
        <h4 className={clsx("md:text-xl", "mt-4")}>
          {info.fields.emailHeader}
        </h4>
        <a
          href={`mailto:${info.fields.email}`}
          className={clsx("hover:underline", "text-dark-blue-80")}
          aria-label="Email"
        >
          {info.fields.email}
        </a>
        <h4 className={clsx("md:text-xl", "mt-4")}>
          {info.fields.billingAddressHeader}
        </h4>
        <p>{info.fields.billingAddress}</p>
        <h4 className={clsx("md:text-xl", "mt-4")}>
          {info.fields.visitingAdressHeader}
        </h4>
        <p>{info.fields.visitingAddress}</p>
        <h4 className={clsx("md:text-xl", "mt-4")}>
          {info.fields.organizationNumberHeader}
        </h4>
        <p className={clsx("md:col-start-1")}>
          {info.fields.organizationNumber}
        </p>
        <DynamicMap
          latlng={{ lat: 55.70435, lng: 13.19252 }} // Modity office
          className={clsx("md:row-start-1", "md:row-end-[9]", "md:col-start-2")}
        />
      </div>
    </section>
  );
}
